<nb-card>
  <nb-card-header>{{ title }}</nb-card-header>
  <nb-card-body [innerHTML]="content"></nb-card-body>
  <nb-card-footer>
    <button *ngIf="withConfirmation" nbButton hero status="success" (click)="dismiss(true)">{{ "UTILS.YES" | translate }}</button>
    <button *ngIf="withConfirmation" nbButton hero status="danger" (click)="dismiss(false)">{{ "UTILS.NO" | translate }}</button>
    <button *ngIf="!withConfirmation" nbButton hero status="success" (click)="dismiss(true)">{{ "UTILS.OK" | translate }}</button>
  </nb-card-footer>
</nb-card>
